export const TYPES = {
  NegotiationCloser: Symbol.for('NegotiationCloser'),
};